import React from 'react';
import { Bronze } from './icons/Bronze.js';
import { Silver } from './icons/Silver.js';
import { Gold } from './icons/Gold.js';
import { Platinum } from './icons/Platinum.js';
import { Pearl } from './icons/Pearl.js';
import { Onyx } from './icons/Onyx.js';
import { Diamond } from './icons/Diamond.js';
import { Palladium } from './icons/Palladium.js';
import { Castle } from './icons/Castle.js';
import bronze from './images/bronze.png.js';
import silver from './images/silver.png.js';
import gold from './images/gold.png.js';
import platinum from './images/platinum.png.js';
import pearl from './images/pearl.png.js';
import onyx from './images/onyx.png.js';
import diamond from './images/diamond.png.js';
import palladium from './images/palladium.png.js';
import castle from './images/castle.png.js';

const RewardIconStr = {
  zero: bronze,
  rookie: bronze,
  bronze,
  silver,
  gold,
  platinum,
  pearl,
  onyx,
  diamond,
  palladium,
  castle
};
const RewardIcon = ({ icon, stringType }) => {
  if (stringType) {
    return /* @__PURE__ */ React.createElement(
      "img",
      {
        "data-vip-image": icon,
        src: RewardIconStr[icon] || icon,
        alt: "reward icon"
      }
    );
  }
  const icon2 = icon?.toLowerCase();
  if (!icon2) {
    return null;
  }
  if (icon2.includes("zero") || icon2?.includes("rookie")) {
    return /* @__PURE__ */ React.createElement(Bronze, null);
  }
  if (icon2.includes("bronze")) {
    return /* @__PURE__ */ React.createElement(Bronze, null);
  }
  if (icon2.includes("silver")) {
    return /* @__PURE__ */ React.createElement(Silver, null);
  }
  if (icon2.includes("gold")) {
    return /* @__PURE__ */ React.createElement(Gold, null);
  }
  if (icon2.includes("platinum")) {
    return /* @__PURE__ */ React.createElement(Platinum, null);
  }
  if (icon2.includes("pearl")) {
    return /* @__PURE__ */ React.createElement(Pearl, null);
  }
  if (icon2.includes("onyx")) {
    return /* @__PURE__ */ React.createElement(Onyx, null);
  }
  if (icon2.includes("diamond")) {
    return /* @__PURE__ */ React.createElement(Diamond, null);
  }
  if (icon2.includes("palladium")) {
    return /* @__PURE__ */ React.createElement(Palladium, null);
  }
  if (icon2.includes("castle")) {
    return /* @__PURE__ */ React.createElement(Castle, null);
  }
  return null;
};
RewardIcon.displayName = "RewardIcon";

export { RewardIcon, RewardIconStr };
//# sourceMappingURL=index.js.map
